export default class AppraisalCycleStepManager {
    static getAllCreationSteps(onClickHandler) {
        // const countryCode = TenantService.get(TENANT.COUNTRY_CODE);
        let steps = [];

        const appraisalDetails = {
            title: "Appraisal Cycle Details",
            requiredProps: [],
            reqError: "Please fill all the mandatory details",
            // getChild: (props) => (
            //     <EmployeeDetails
            //         {...props}
            //         // key={"1"}
            //         userId={props.userId}
            //         setData={props.setData}
            //         ref={props.ref}
            //         isEdit={props.isEdit}
            //         isEditState={props.isEditState}
            //     />
            // ),
            onClick: (event) => onClickHandler(event, 0),
        }
        const questions = {
            title: "Questions",
            requiredProps: [],
            reqError: "Please fill all the mandatory details",
            // getChild: (props) => (
            //     <EmployeeDetails
            //         {...props}
            //         // key={"1"}
            //         userId={props.userId}
            //         setData={props.setData}
            //         ref={props.ref}
            //         isEdit={props.isEdit}
            //         isEditState={props.isEditState}
            //     />
            // ),
            onClick: (event) => onClickHandler(event, 1),
        }
        steps = [appraisalDetails, questions]
        return steps
    }
}